import React from 'react';
import { Route } from '@/navigation/Route';
import { FinishedEventDetailScreen } from './screens';

export const FINISHED_EVENT_DETAIL_ROUTES = {
  itself: '/dashboard/event/finished/detail/:id',
};

export const FinishedEventDetailNavigation = (): JSX.Element => (
  <Route
    exact
    path={FINISHED_EVENT_DETAIL_ROUTES.itself}
    component={FinishedEventDetailScreen}
    isPrivateRoute
  />
);
